"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Agent = void 0;
var JSONSignedCertificate_1 = __importStar(require("../lib/JSONSignedCertificate"));
var JSONCertificateRequest_1 = __importStar(require("../lib/JSONCertificateRequest"));
var KeyPair_1 = __importDefault(require("../lib/KeyPair"));
var TokenFormat_1 = require("../lib/TokenFormat");
var JSONChainedToken_1 = __importStar(require("../lib/JSONChainedToken"));
var ValidatingAgent_1 = __importDefault(require("./ValidatingAgent"));
var AbstractAuthorityServer_1 = require("./AbstractAuthorityServer");
var ResourceIdentifier_1 = require("../lib/ResourceIdentifier");
var UUID_1 = __importDefault(require("../lib/UUID"));
var shared_1 = require("../lib/b64/shared");
var debug_1 = __importDefault(require("debug"));
var AuthorizationForwarder = __importStar(require("./AuthorizationForwarder"));
var CertRequestValidationError_1 = require("./CertRequestValidationError");
var JSONWebToken_1 = __importStar(require("../lib/JSONWebToken"));
var RSA_1 = __importDefault(require("../lib/RSA"));
var debug = (0, debug_1.default)('jwt-cert-sdk:Agent');
function serialize(obj) {
    return (0, TokenFormat_1.encode)(obj);
}
function unserialize(str) {
    return (0, TokenFormat_1.decode)(str);
}
var UnknownCertNickname = /** @class */ (function (_super) {
    __extends(UnknownCertNickname, _super);
    function UnknownCertNickname() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnknownCertNickname;
}(Error));
var CertWillExpire = /** @class */ (function (_super) {
    __extends(CertWillExpire, _super);
    function CertWillExpire() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CertWillExpire;
}(Error));
var Agent = /** @class */ (function (_super) {
    __extends(Agent, _super);
    function Agent(identity, keypair, deviceName) {
        var _this = _super.call(this) || this;
        _this.certificates = {};
        _this._last_jct_writer = null;
        _this._resourceAutorizationHandler = [];
        _this.identity = identity;
        _this.keypair = keypair;
        _this.deviceName = deviceName;
        return _this;
    }
    Agent.generate_key = function () {
        return __awaiter(this, arguments, void 0, function (keylength) {
            if (keylength === void 0) { keylength = 512; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, KeyPair_1.default.generate_new(keylength)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Re-instanciate an agent based on a previous serialized version.
     * Authorities need to be re-added manually
     * @param payload previously srialized Agent
     */
    Agent.unserialize = function (payload) {
        var obj = unserialize(payload);
        var agent = new Agent(obj.identity, new KeyPair_1.default({
            keyid: obj.keypair.kid,
            data: obj.keypair.prv,
        }, {
            keyid: obj.keypair.kid,
            data: obj.keypair.pub,
        }), obj.deviceName);
        obj.certificates.forEach(function (e) {
            agent.certificates[e.nickname] = new JSONSignedCertificate_1.default(e.cert);
        });
        return agent;
    };
    /**
     * Return a string encoded version of this Agent, that can be stored for later instanciation using Agent.unserialize.
     * Note: The private key will be returned UN-ENCRYPTED. The value MUST not be shared
     */
    Agent.prototype.serialize = function () {
        var certs = [];
        for (var nickname in this.certificates)
            certs.push({
                nickname: nickname,
                cert: this.certificates[nickname].raw,
            });
        return serialize(__assign(__assign({ identity: this.identity, keypair: {
                prv: this.keypair.prv.data,
                pub: this.keypair.pub.data,
                kid: this.keypair.keyid,
            } }, (this.deviceName ? { deviceName: this.deviceName } : {})), { certificates: certs }));
    };
    /**
     * override this method if you want to use a specified storage for this
     * agent instead of keeping those in memory and serializing the whole thing
     * everytime.
     */
    // override start //////////////////////////////////////////////////////////
    /**
     * Store the certificate for later use.
     *
     * If one already existed under that key, it SHOULD be revoked (unless it is
     * already expired) before a new one is stored. This method does not look
     * for that, the responsability is on the calling code.
     *
     * @param nickname unique key for this certificate
     * @param cert certificate to store. if needed, it can be serialized with
     * .raw
     */
    Agent.prototype.dbStoreCertificate = function (cert, nickname) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.certificates[nickname] = cert;
                return [2 /*return*/, true];
            });
        });
    };
    /**
     * Remove a previously stored certificate from storage.
     *
     * @param nickname unique key for this certificate
     * @return true if it was deleted, false if it didn't exists
     */
    Agent.prototype.dbDeleteCertificateByNickname = function (nickname) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (nickname in this.certificates) {
                    delete this.certificates[nickname];
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
            });
        });
    };
    /**
     * Remove a previously stored certificate, based on the .certificate_id.
     *
     * @param cert Certificate to delete
     * @return true if it was deleted, false if it didn't exists
     */
    Agent.prototype.dbDeleteCertificate = function (cert) {
        return __awaiter(this, void 0, void 0, function () {
            var k;
            return __generator(this, function (_a) {
                for (k in this.certificates) {
                    if (this.certificates[k].certificate_id === cert.certificate_id) {
                        delete this.certificates[k];
                        return [2 /*return*/, true];
                    }
                }
                return [2 /*return*/, false];
            });
        });
    };
    /**
     * Retrieve a certificate from storage, encoded or not
     * @param nickname unique key for this certificate
     */
    Agent.prototype.dbGetCertificate = function (nickname) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (nickname in this.certificates) {
                    return [2 /*return*/, this.certificates[nickname]];
                }
                return [2 /*return*/, null];
            });
        });
    };
    /**
     * Retrieve the full list of certificate nickname from storage
     */
    Agent.prototype.dbGetAllCertificateNicknames = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Object.keys(this.certificates)];
            });
        });
    };
    // override end ////////////////////////////////////////////////////////////
    /**
     * Will fetch a certificate from the storage, and will make sure the
     * returned object is an instanciated JSC.
     *
     * Optionally, a renew handle can be provided and will be called if the
     * certificate does not exists, or if the also optional expiration_in time
     * is passed and the certificate would expire before then
     */
    Agent.prototype.getInflatedCertificate = function (nickname, still_valid_in, cert_renew_handler) {
        return __awaiter(this, void 0, void 0, function () {
            var cert, newCert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug('fetching certificate %s', nickname);
                        return [4 /*yield*/, this.dbGetCertificate(nickname)];
                    case 1:
                        cert = _a.sent();
                        if (typeof cert === 'string') {
                            cert = new JSONSignedCertificate_1.default(cert);
                        }
                        if (!(still_valid_in && cert_renew_handler && (cert === null || cert.shouldBeRenewed(still_valid_in)))) return [3 /*break*/, 3];
                        return [4 /*yield*/, cert_renew_handler(nickname)];
                    case 2:
                        newCert = _a.sent();
                        if (newCert) {
                            debug('returning renewed certificate %s %o', nickname, newCert);
                            return [2 /*return*/, newCert];
                        }
                        _a.label = 3;
                    case 3:
                        debug('returning inflated certificate %s %o', nickname, cert);
                        return [2 /*return*/, cert];
                }
            });
        });
    };
    /**
     * Instanciate a JCT Writer. Only keep the last one used in cache for the
     * time being.
     *
     * TODO look to have an optimized cache of 5 or so items? with a rotation by
     * droping the one that was last used the last? or something like that
     */
    Agent.prototype._get_jct_writer = function (cert_nickname, exp_in, cert_renew_handler) {
        return __awaiter(this, void 0, void 0, function () {
            var cert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this._last_jct_writer === null || this._last_jct_writer.nickname !== cert_nickname)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getInflatedCertificate(cert_nickname, exp_in, cert_renew_handler)];
                    case 1:
                        cert = _a.sent();
                        if (!cert) {
                            debug('unknown cert name %s ', cert_nickname);
                            throw new UnknownCertNickname('Unknown certificate nickname ' + cert_nickname);
                        }
                        if (!('kid' in cert.body)) {
                            debug('no kid in certificate, going in blind');
                        }
                        else if (cert.body.kid !== this.keypair.keyid) {
                            debug('key pair keyid "%s" does not match cert keyid "%s"', this.keypair.keyid, cert.body.kid);
                            throw new Error('Certificate keyid does not match current private key');
                        }
                        this._last_jct_writer = {
                            nickname: cert_nickname,
                            writer: new JSONChainedToken_1.JCTWriter(cert, this.keypair.prv),
                        };
                        _a.label = 2;
                    case 2:
                        if (!(exp_in && this._last_jct_writer.writer.cert.willExpireIn(exp_in))) return [3 /*break*/, 7];
                        if (!!cert_renew_handler) return [3 /*break*/, 3];
                        throw new CertWillExpire('Certificate will expire, and no renew handler provided');
                    case 3:
                        if (!this._last_jct_writer.writer.cert.shouldBeRenewed(exp_in)) return [3 /*break*/, 6];
                        return [4 /*yield*/, cert_renew_handler(cert_nickname)];
                    case 4:
                        _a.sent();
                        // clear the last_jct writer to load the new certifiate
                        this._last_jct_writer = null;
                        return [4 /*yield*/, this._get_jct_writer(cert_nickname, exp_in)];
                    case 5: 
                    // recall ourself, but do not provide the cert_renew_handler
                    return [2 /*return*/, _a.sent()];
                    case 6: throw new CertWillExpire("Certificate will expire, and exp_in (".concat(exp_in, ") is higher than configured cert ttl (").concat(this._last_jct_writer.writer.cert.certTtl, ")"));
                    case 7: return [2 /*return*/, this._last_jct_writer.writer];
                }
            });
        });
    };
    Agent.prototype.generateJWT = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var writer;
            return __generator(this, function (_a) {
                writer = new JSONWebToken_1.JWTWriter(payload);
                return [2 /*return*/, writer.sign(this.keypair.prv)];
            });
        });
    };
    Agent.prototype.parseJWT = function (jwt, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.verifyJWT(new JSONWebToken_1.default(jwt, 'JWT'), options)];
            });
        });
    };
    Agent.prototype.verifyJWT = function (reader, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, valid, errors;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, reader.verify(typeof (options === null || options === void 0 ? void 0 : options.pub) === 'undefined'
                            ? this.keypair.pub
                            : typeof options.pub === 'boolean'
                                ? options.pub
                                : { data: options.pub }, options)];
                    case 1:
                        _a = _b.sent(), valid = _a[0], errors = _a[1];
                        if (!valid) {
                            throw new Error('Invalid JWT ' + errors.join(','));
                        }
                        return [2 /*return*/, reader];
                }
            });
        });
    };
    // parse any of JWT(self signed) or JCT
    Agent.prototype.parseToken = function (rawToken, options) {
        return __awaiter(this, void 0, void 0, function () {
            var reader;
            return __generator(this, function (_a) {
                try {
                    reader = new JSONWebToken_1.default(rawToken, 'JWT');
                }
                catch (err) {
                    return [2 /*return*/, this.parseJCT(rawToken, options)];
                }
                return [2 /*return*/, this.verifyJWT(reader, options)];
            });
        });
    };
    Agent.prototype.generateJCT = function () {
        return __awaiter(this, arguments, void 0, function (payload, exp_in_or_options, cert_nickname, cert_renew_handler) {
            var options, writer, jct;
            if (payload === void 0) { payload = {}; }
            if (exp_in_or_options === void 0) { exp_in_or_options = 30; }
            if (cert_nickname === void 0) { cert_nickname = 'default'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = null;
                        if (typeof exp_in_or_options === 'object' && exp_in_or_options) {
                            options = exp_in_or_options;
                        }
                        else {
                            options = {
                                exp_in: exp_in_or_options,
                                cert_nickname: cert_nickname,
                                cert_renew_handler: cert_renew_handler,
                                compress: false,
                                lightweight: false,
                            };
                        }
                        if (!options.cert_nickname) {
                            options.cert_nickname = 'default';
                        }
                        if (typeof options.exp_in === 'undefined') {
                            options.exp_in = 30;
                        }
                        debug('generating JCT - cert:%s, exp:%d  %O', options.cert_nickname, options.exp_in, payload);
                        return [4 /*yield*/, this._get_jct_writer(options.cert_nickname, options.exp_in, options.cert_renew_handler)];
                    case 1:
                        writer = _a.sent();
                        return [4 /*yield*/, writer.sign(payload, options.exp_in, options.compress, options.lightweight)];
                    case 2:
                        jct = _a.sent();
                        debug('returning JCT - cert:%s, exp:%d %O. Result %s', options.cert_nickname, options.exp_in, payload, jct);
                        return [2 /*return*/, jct];
                }
            });
        });
    };
    Agent.prototype.generateAuthenticationJCT = function () {
        return __awaiter(this, arguments, void 0, function (payload, exp_in_or_options, cert_nickname, cert_etc_on_renew, cert_ttl_on_renew) {
            var cert_ttl_on_renew_default, options, filled_options;
            var _this = this;
            if (payload === void 0) { payload = {}; }
            if (exp_in_or_options === void 0) { exp_in_or_options = 30; }
            if (cert_nickname === void 0) { cert_nickname = 'default'; }
            if (cert_etc_on_renew === void 0) { cert_etc_on_renew = {}; }
            if (cert_ttl_on_renew === void 0) { cert_ttl_on_renew = 24 * 60 * 60; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cert_ttl_on_renew_default = 365 * 24 * 60 * 60;
                        options = null;
                        if (typeof exp_in_or_options === 'object' && exp_in_or_options) {
                            options = exp_in_or_options;
                            if (!('cert_nickname' in options)) {
                                options.cert_nickname = 'default' + (options.lightweight ? ':l' : '') + (options.compress ? ':c' : '');
                            }
                        }
                        else {
                            options = {
                                exp_in: exp_in_or_options,
                                cert_nickname: cert_nickname,
                                compress: false,
                                cert_etc_on_renew: cert_etc_on_renew,
                                cert_ttl_on_renew: cert_nickname === 'default' ? cert_ttl_on_renew_default : cert_ttl_on_renew,
                            };
                        }
                        if (typeof options.cert_etc_on_renew === 'undefined') {
                            options.cert_etc_on_renew = {};
                        }
                        if (typeof options.cert_ttl_on_renew === 'undefined') {
                            options.cert_ttl_on_renew = cert_nickname === 'default' ? cert_ttl_on_renew_default : 24 * 60 * 60;
                        }
                        filled_options = options;
                        if (!options.cert_renew_handler) {
                            options.cert_renew_handler = function (cert_nickname) {
                                return _this.requestNewCertificate(filled_options.cert_etc_on_renew, filled_options.cert_ttl_on_renew, cert_nickname, undefined, filled_options.lightweight, filled_options.compress);
                            };
                        }
                        debug('Generating Authentication JCT, %O', filled_options);
                        return [4 /*yield*/, this.generateJCT(payload, filled_options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Agent.prototype.generateResourceJCT = function (resourceUri_1) {
        return __awaiter(this, arguments, void 0, function (resourceUri, payload, exp_in_or_options) {
            var options;
            var _this = this;
            if (payload === void 0) { payload = {}; }
            if (exp_in_or_options === void 0) { exp_in_or_options = 30; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = typeof exp_in_or_options === 'number'
                            ? {
                                exp_in: exp_in_or_options,
                                compress: false,
                            }
                            : exp_in_or_options;
                        options.cert_nickname =
                            'autz:' +
                                (options.lightweight ? 'l:' : '') +
                                (options.compress ? 'c:' : '') +
                                this.getResourceSlug(resourceUri);
                        (options.cert_renew_handler = function () {
                            return _this.requestNewResourceCertificate(resourceUri, undefined, undefined, options.lightweight, options.compress);
                        }),
                            debug('Generating Resource JCT for %s', resourceUri);
                        return [4 /*yield*/, this.generateJCT(payload, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Agent.prototype.getResourceSlug = function (resourceUri) {
        return "resource:".concat(resourceUri);
    };
    /**
     * Centralized function to validate the validity of a certificate request
     * @param jcr Certificate Request
     * @param dest_identity Expected identity for the certificate
     */
    Agent.prototype.verifyCertificateRequest = function (jcr, dest_identity) {
        return __awaiter(this, void 0, void 0, function () {
            var dest_identity_cert, obtained_dest_cert_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug('Veryfing cert request %O', jcr.body);
                        if (jcr.sub !== dest_identity.sub) {
                            debug('verifyCertificateRequest - jcr.sub "%s" does not match identity sub "%s"', jcr.sub, dest_identity.sub);
                            throw new CertRequestValidationError_1.CertRequestValidationError('Provided identity and certificate identity does not match');
                        }
                        return [4 /*yield*/, jcr.verify_signature()];
                    case 1:
                        if (!(_a.sent())) {
                            debug('verifyCertificateRequest - signature error');
                            throw new CertRequestValidationError_1.CertRequestValidationError('Invalid signature');
                        }
                        if (jcr.body.ecs && jcr.body.ecs.length) {
                            dest_identity_cert = null;
                            if (dest_identity instanceof JSONSignedCertificate_1.default) {
                                dest_identity_cert = dest_identity;
                            }
                            else if (dest_identity instanceof JSONChainedToken_1.default) {
                                dest_identity_cert = dest_identity.cert;
                            }
                            obtained_dest_cert_1 = dest_identity_cert;
                            if (obtained_dest_cert_1 === null) {
                                debug('verifyCertificateRequest - ecs w/o dest_identity: JSC|JCT');
                                throw new CertRequestValidationError_1.CertRequestValidationError('Cannot have extended certificate_id without dest_identity as JSC or JCT');
                            }
                            jcr.body.ecs.forEach(function (extended_certificate_id) {
                                if (extended_certificate_id === obtained_dest_cert_1.certificate_id) {
                                    // all good
                                    debug('verifyCertificateRequest - ecs is obtained_dest_cert certificate_id');
                                }
                                else if (obtained_dest_cert_1.body.ecs &&
                                    obtained_dest_cert_1.body.ecs.includes(extended_certificate_id)) {
                                    // still all good
                                    debug('verifyCertificateRequest - ecs is part of obtained_dest_cert extended_certificate_ids');
                                }
                                else {
                                    debug('verifyCertificateRequest - ecs nothing that we expected');
                                    throw new Error('Extended certificate id not contained in the identity certificate');
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Signs a certificate and return the chain required to validate it
     * @param jcr Certificate Request
     * @param dest_identity expected Identity of the certificate request
     * @param cert_nickname the name of the certificate to use to sign and add to the chain
     */
    Agent.prototype.signCertificate = function (jcr_1, dest_identity_1) {
        return __awaiter(this, arguments, void 0, function (jcr, dest_identity, cert_nickname, additional_etc, ttl_max) {
            var cert;
            if (cert_nickname === void 0) { cert_nickname = 'default'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifyCertificateRequest(jcr, dest_identity)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, (typeof cert_nickname === 'string'
                                ? this.getInflatedCertificate(cert_nickname)
                                : this.getInflatedCertificate(cert_nickname.nickname, ttl_max, cert_nickname.renew))];
                    case 2:
                        cert = _a.sent();
                        if (!cert) {
                            throw new Error("unknown certificate \"".concat(cert_nickname, "\""));
                        }
                        if (!('keyid' in cert.pub)) {
                            debug('lightweight certificate, not checking keyid');
                        }
                        else if (cert.pub.keyid !== this.keypair.keyid) {
                            debug('certificate "%s" keyid "%s" does not match primary key id "%s"', cert_nickname, cert.pub.keyid, this.keypair.keyid);
                            throw new Error("invalid certificate \"".concat(cert_nickname, "\", does not match current private key"));
                        }
                        return [4 /*yield*/, this.signVerifiedCertificate(jcr, dest_identity, cert, additional_etc, ttl_max)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Standardize signature of resource certificate. When signed with this
     * method, any agent will be able to fetch the pertinent information using
     * the helper function on the JCT (noticibly:
     *  - .service_authorized_resource,
     *  - .service_authorized_resource_uri
     *    )
     * @param jcr Certificate request
     * @param dest_identity Identity of the party this is signed for
     * @param resourceType The type of resource this is identifying
     * @param resourceId The unique (among all resource of same type within this
     * service) resource id,
     * @param permissions The list of permissions to add to the certificate
     * @param cert_etc Any additional information to add to the certificate
     * @param cert_nickname_prefix value that will be prefixed to the
     * certificate name (see .signServiceCertificate for more information)
     */
    Agent.prototype.signServiceAuthorizationCertificate = function (jcr_1, dest_identity_1, resourceType_1, resourceId_1, permissions_1) {
        return __awaiter(this, arguments, void 0, function (jcr, dest_identity, resourceType, resourceId, permissions, cert_etc, max_ttl, cert_nickname_prefix) {
            var _a, _b, _c;
            if (cert_etc === void 0) { cert_etc = {}; }
            if (cert_nickname_prefix === void 0) { cert_nickname_prefix = 'service:'; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        debug('Signing Service Authorization Certificate for <%s> %s', resourceType, resourceId);
                        if (!ResourceIdentifier_1.ResourceUriRegex.test(resourceType)) {
                            throw new Error("Invalid resource type, must match pattern ".concat(ResourceIdentifier_1.ResourceUriPattern));
                        }
                        if (!ResourceIdentifier_1.ResourceUriRegex.test(resourceId)) {
                            throw new Error("Invalid resource id, must match pattern ".concat(ResourceIdentifier_1.ResourceUriPattern));
                        }
                        _a = this.signServiceCertificate;
                        _b = [jcr,
                            dest_identity, __assign(__assign({}, cert_etc), { resId: resourceId, resTyp: resourceType, prms: permissions }), max_ttl];
                        // These certificate should not be revoked when a new one is signed.
                        // For this reason, we are adding a uuid to the cert nickname
                        // generated here.
                        _c = cert_nickname_prefix + '-';
                        return [4 /*yield*/, (0, UUID_1.default)()];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([
                            // These certificate should not be revoked when a new one is signed.
                            // For this reason, we are adding a uuid to the cert nickname
                            // generated here.
                            _c + (_d.sent())]))];
                    case 2: return [2 /*return*/, _d.sent()];
                }
            });
        });
    };
    /**
     * Generate a new certificate for this service and return a signed chain
     * certificate
     *
     * Identity is not verified here, other than confirming that it matches the
     * dest_identity provided. The code calling this function is responsible of
     * confirming that before hand
     * @param jcr Certificate Request
     * @param dest_identity expected Identity of the certificate request
     * @param cert_nickname_prefix value that will be prefixed to the generated
     * certificate nickname
     */
    Agent.prototype.signServiceCertificate = function (jcr_1, dest_identity_1) {
        return __awaiter(this, arguments, void 0, function (jcr, dest_identity, cert_etc, ttl_max, cert_nickname_prefix) {
            var cert_nickname, cert;
            if (cert_etc === void 0) { cert_etc = {}; }
            if (ttl_max === void 0) { ttl_max = 90 * 24 * 60 * 60; }
            if (cert_nickname_prefix === void 0) { cert_nickname_prefix = 'service:'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug('signServiceCertificate - verifying request %O', jcr);
                        return [4 /*yield*/, this.verifyCertificateRequest(jcr, dest_identity)];
                    case 1:
                        _a.sent();
                        cert_nickname = cert_nickname_prefix + dest_identity.sub;
                        debug('signServiceCertificate - requesting authentication certificate');
                        return [4 /*yield*/, this.requestNewCertificate(cert_etc, ttl_max, cert_nickname, undefined, jcr.body.lightweight, jcr.body.compressed)];
                    case 2:
                        cert = _a.sent();
                        debug('signServiceCertificate - signing certificate');
                        return [4 /*yield*/, this.signVerifiedCertificate(jcr, dest_identity, cert, {}, ttl_max)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Sign a certificate request with a resource authorization certificate
     *
     * Initial usage is for a user to grant temporary access to a third party
     * service so that they can get their own certificate signed by the resource
     * owner
     */
    Agent.prototype.signResourceCertificate = function (resourceUri_1, serviceJcr_1, serviceJct_1, permissions_1) {
        return __awaiter(this, arguments, void 0, function (resourceUri, serviceJcr, serviceJct, permissions, ttl_max) {
            var cert_nickname, _a, _b, _c;
            var _this = this;
            if (ttl_max === void 0) { ttl_max = 600; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        cert_nickname = 'autz:' + this.getResourceSlug(resourceUri);
                        _a = this.signCertificate;
                        _b = [typeof serviceJcr === 'string' ? new JSONCertificateRequest_1.default(serviceJcr) : serviceJcr];
                        if (!(typeof serviceJct === 'object' && serviceJct instanceof JSONChainedToken_1.default)) return [3 /*break*/, 1];
                        _c = serviceJct;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.parseJCT(serviceJct)];
                    case 2:
                        _c = _d.sent();
                        _d.label = 3;
                    case 3: return [4 /*yield*/, _a.apply(this, _b.concat([_c, { nickname: cert_nickname, renew: function () { return _this.requestNewResourceCertificate(resourceUri); } },
                            // TODO add validation to ensure the permissions limited here were
                            // originally included in the certificiate used to sign it
                            { prms: permissions },
                            ttl_max]))];
                    case 4: return [2 /*return*/, _d.sent()];
                }
            });
        });
    };
    /**
     * Skip verification and certificate obtention. mainly used internaly
     * @param jcr Certificate Request. Expected that identity matches, and
     * signature is valid
     * @param dest_identity confirmed identity for the Certificate Request
     * @param cert
     */
    Agent.prototype.signVerifiedCertificate = function (jcr_1, dest_identity_1, cert_1, additionalEtc_1) {
        return __awaiter(this, arguments, void 0, function (jcr, dest_identity, cert, additionalEtc, ttl_max) {
            var writer;
            if (ttl_max === void 0) { ttl_max = 90 * 24 * 60 * 60; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        writer = new JSONSignedCertificate_1.JSCWriter(this.keypair.prv, this.identity.sub, ttl_max);
                        debug('signing verified certificate %O', jcr.body);
                        return [4 /*yield*/, writer.sign(jcr, dest_identity, cert, additionalEtc, jcr.body.lightweight, jcr.body.compressed)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Generate a new certificate signature request.
     *
     * @param etc Additional information to add in the certificate request
     * @param ttl desired time to live for the certificate. The signee is the
     * authority for what value ultimately get's entered here
     * @param ecs Extending Certificate ids, additional certificate id that must
     * still be valid for this certificate to be valid
     */
    Agent.prototype.generateCertificateRequest = function () {
        return __awaiter(this, arguments, void 0, function (etc, ttl, ecs, lightWeight, compressed) {
            var exp;
            if (etc === void 0) { etc = {}; }
            if (ttl === void 0) { ttl = null; }
            if (ecs === void 0) { ecs = undefined; }
            if (lightWeight === void 0) { lightWeight = false; }
            if (compressed === void 0) { compressed = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.identity.sub) {
                            throw new Error('Cannot generate certificate request without a valid identity.sub');
                        }
                        if (this.deviceName) {
                            etc.device_name = this.deviceName;
                        }
                        exp = ttl ? (0, AbstractAuthorityServer_1.TimestampNow)() + ttl : null;
                        debug('Generating certificate request, sub: %s, exp: %d, ecs:%o, etc: %O, lightweight:%o, compressed: %o', this.identity.sub, exp, ecs, etc, lightWeight, compressed);
                        return [4 /*yield*/, JSONCertificateRequest_1.JCRWriter.fromKeyPair(this.keypair, this.identity.sub, etc, exp, ecs, lightWeight, compressed)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Register the handle to automatically used to retrieve authorization token
     * for a pattern of resource Uri
     *
     * Handlers will be checked in order they were created
     *
     * @param resourceUri Regex or string prefix that a resourceUri must have to have this handle used
     * @param handle callback that sends the certificate requests and returns the signed certificate
     */
    Agent.prototype.registerAuthorizationHandler = function (resourceUri, handle, getAuthRequirement, etc, ttl) {
        debug('Registering authorization handler for', resourceUri);
        this._resourceAutorizationHandler.push({
            uri: resourceUri,
            handle: handle,
            getAuthRequirement: getAuthRequirement,
            etc: etc,
            ttl: ttl,
        });
    };
    /**
     * Request and store a new certificate for a certain resource
     */
    Agent.prototype.requestNewResourceCertificate = function (resourceUri, etc, ttl, lightWeight, compress) {
        return __awaiter(this, void 0, void 0, function () {
            var handler, matches;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        handler = this._resourceAutorizationHandler.find(function (handler) {
                            return typeof handler.uri === 'string'
                                ? resourceUri.startsWith(handler.uri)
                                : handler.uri.test(resourceUri);
                        });
                        if (!handler) {
                            debug('No Resource Authorization Handler for %s', resourceUri);
                            throw new Error("Unkown resource uri ".concat(resourceUri, ", cannot find authorization handler"));
                        }
                        matches = typeof handler.uri === 'string' ? null : resourceUri.match(handler.uri);
                        debug('auto providing authorization certificate for resource %s', resourceUri);
                        return [4 /*yield*/, this.requestNewAuthorizationCertificate(resourceUri, handler.getAuthRequirement ? handler.getAuthRequirement(resourceUri, matches) : null, function (jcr, jct) { return handler.handle(jcr, jct, resourceUri, matches); }, __assign(__assign({}, handler.etc), { etc: etc }), ttl && (!handler.ttl || ttl < handler.ttl) ? ttl : handler.ttl, lightWeight, compress)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Generate a new authorization certificate for a certain resource.
     * This will in turn create an authentication certificate that can be used
     * to revoke access to the expected chained authorization certificate
     *
     * @param resourceUri Which resource is this getting access to
     * @param handle Sends the certificate request and returns the encoded signed certificate
     * @param etc anything else to add?
     * @param ttl time to live for this certificate
     */
    Agent.prototype.requestNewAuthorizationCertificate = function (resourceUri_1, authRequirement_1, handle_1) {
        return __awaiter(this, arguments, void 0, function (resourceUri, authRequirement, handle, etc, ttl, lightweight, compress) {
            var resource_slug, authRequiredResourceUri, jctBody, encoded_jct, jct;
            if (etc === void 0) { etc = {}; }
            if (ttl === void 0) { ttl = null; }
            if (lightweight === void 0) { lightweight = false; }
            if (compress === void 0) { compress = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource_slug = this.getResourceSlug(resourceUri);
                        debug('[autz:%s] Generating JCT (authRequirement: %o)', resource_slug, authRequirement);
                        authRequiredResourceUri = typeof authRequirement === 'string'
                            ? authRequirement
                            : typeof (authRequirement === null || authRequirement === void 0 ? void 0 : authRequirement.resourceUri) === 'string'
                                ? authRequirement.resourceUri
                                : null;
                        jctBody = typeof authRequirement === 'object' && typeof (authRequirement === null || authRequirement === void 0 ? void 0 : authRequirement.jctBody) !== 'undefined'
                            ? authRequirement.jctBody
                            : {};
                        return [4 /*yield*/, (authRequiredResourceUri
                                ? this.generateResourceJCT(authRequiredResourceUri, jctBody, { exp_in: 30, compress: compress, lightweight: lightweight })
                                : this.generateAuthenticationJCT(jctBody, 30, "auth:".concat(resource_slug), {
                                    resUri: resourceUri,
                                }))];
                    case 1:
                        encoded_jct = _a.sent();
                        jct = new JSONChainedToken_1.default(encoded_jct);
                        debug('[autz:%s] Requesting Generic Certificate', resource_slug);
                        return [4 /*yield*/, this.requestGenericCertificate(function (jcr) { return handle(jcr, encoded_jct); }, "autz:".concat(resource_slug), etc, ttl, jct.cert.extended_certificate_ids, lightweight, compress)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Agent.prototype.requestGenericCertificate = function (handle_1, cert_nickname_1) {
        return __awaiter(this, arguments, void 0, function (handle, cert_nickname, etc, ttl, ecs, lightweight, compressed) {
            var _a, jsc_maybe_encoded, oldCert, jsc;
            var _b;
            if (etc === void 0) { etc = {}; }
            if (ttl === void 0) { ttl = null; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        debug('[certRequest: %s] Requesting Generic Certificate', cert_nickname);
                        return [4 /*yield*/, Promise.all([
                                this.generateCertificateRequest(etc, ttl, ecs, lightweight, compressed).then(function (jcr_encoded) {
                                    debug('[certRequest: %s] Requesting Generic Certificate', cert_nickname);
                                    return handle(jcr_encoded);
                                }),
                                this.getInflatedCertificate(cert_nickname),
                            ])];
                    case 1:
                        _a = _c.sent(), jsc_maybe_encoded = _a[0], oldCert = _a[1];
                        if (typeof jsc_maybe_encoded === 'undefined' || !jsc_maybe_encoded) {
                            throw new Error('Failed to retrieve signed certificate name ' + cert_nickname);
                        }
                        jsc = typeof jsc_maybe_encoded === 'string' ? new JSONSignedCertificate_1.default(jsc_maybe_encoded) : jsc_maybe_encoded;
                        if (typeof jsc.certificate_id !== 'string') {
                            throw new Error('Invalid certificate received for ' + cert_nickname + ', does not contain a certificate_id');
                        }
                        // new cert is signed, we can safely revoked the old one if it existed
                        if (oldCert && !oldCert.isExpired()) {
                            debug('[certRequest: %s] Revoking old cert "%s" that was still valid', cert_nickname, oldCert.certificate_id);
                            // need to revoke this cert
                            this.revokeCertificate(oldCert);
                        }
                        // remove last jct writer from cache
                        if (((_b = this._last_jct_writer) === null || _b === void 0 ? void 0 : _b.nickname) === cert_nickname) {
                            this._last_jct_writer = null;
                        }
                        debug('[certRequest: %s] Storing new certificate "%s"', cert_nickname, jsc.certificate_id);
                        return [4 /*yield*/, this.dbStoreCertificate(jsc, cert_nickname)];
                    case 2:
                        _c.sent();
                        debug('[certRequest: %s] returning certificate');
                        return [2 /*return*/, jsc];
                }
            });
        });
    };
    /**
     * Send a certificate request to the default authority, and return the
     * signed certificate
     * @param etc payload to add to the certificate
     * @param exp requested expiration date for the certificate. Will be capped
     * by whatever the root authority decides
     */
    Agent.prototype.requestNewCertificate = function () {
        return __awaiter(this, arguments, void 0, function (etc, ttl, cert_nickname, authority_nickname, lightweight, compressed) {
            var jsc;
            var _this = this;
            if (etc === void 0) { etc = {}; }
            if (ttl === void 0) { ttl = null; }
            if (cert_nickname === void 0) { cert_nickname = 'default'; }
            if (authority_nickname === void 0) { authority_nickname = 'default'; }
            if (lightweight === void 0) { lightweight = false; }
            if (compressed === void 0) { compressed = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug('[newCert: %s] requesting new authentication certificate', cert_nickname);
                        return [4 /*yield*/, this.requestGenericCertificate(function (jcr_encoded) { return _this.authorities.sign(jcr_encoded, authority_nickname); }, cert_nickname, etc, ttl, undefined, lightweight, compressed)];
                    case 1:
                        jsc = _a.sent();
                        debug('[newCert: %s] returning new authentication certificate %s', cert_nickname, jsc.certificate_id);
                        return [2 /*return*/, jsc];
                }
            });
        });
    };
    /**
     * Fetch the full list of certificate still valid associated with the
     * Agent's identity
     */
    Agent.prototype.getOwnCertificateList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authorities.getOwnCertificateList()];
                    case 1: return [2 /*return*/, (_a.sent()).map(function (encoded) { return new JSONSignedCertificate_1.default(encoded); })];
                }
            });
        });
    };
    Agent.prototype.revokeCertificate = function (cert) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log('Trying to revoke certiticate %s', cert.certificate_id);
                // let revoked = false;
                // try {
                //     console.log('Revoking certiticate %s', cert.certificate_id);
                //     revoked = await this.authorities.revokeCertificate(cert);
                // } catch (err) {
                //     // TODO put this cert in a "to revoked" queue and try again later
                // }
                // console.log('Deleting Revoked certiticate "%s" from storage', cert.certificate_id);
                // // delete it from internal storage
                // await this.dbDeleteCertificate(cert);
                // return revoked;
                return [2 /*return*/, true];
            });
        });
    };
    /**
     * Retrieve certificate for a resource (if any is already stored. Doesn't
     * generate a new one), and revoke it's access.
     * This actually revoke the authentication certificate that was used to sign
     * the authorization certificate, but end result is the same
     *
     * @param resourceUri Resource uri to revoke certificate for
     */
    Agent.prototype.revokeResourceCertificate = function (resourceUri) {
        return __awaiter(this, void 0, void 0, function () {
            var resource_slug, cert_nickname, cert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource_slug = this.getResourceSlug(resourceUri);
                        cert_nickname = "auth:".concat(resource_slug);
                        return [4 /*yield*/, this.getInflatedCertificate(cert_nickname)];
                    case 1:
                        cert = _a.sent();
                        if (!cert) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.revokeCertificate(cert)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Revoke all certificates that were issued to this agent
     */
    Agent.prototype.revokeAllCertificates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var nicknames, count, batch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dbGetAllCertificateNicknames()];
                    case 1:
                        nicknames = _a.sent();
                        count = 0;
                        _a.label = 2;
                    case 2:
                        if (!(nicknames.length > 0)) return [3 /*break*/, 4];
                        batch = nicknames.splice(0, 25);
                        return [4 /*yield*/, Promise.all(batch.map(function (cert_nickname) { return __awaiter(_this, void 0, void 0, function () {
                                var cert, revoked;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.getInflatedCertificate(cert_nickname)];
                                        case 1:
                                            cert = _a.sent();
                                            if (!cert) return [3 /*break*/, 3];
                                            return [4 /*yield*/, this.revokeCertificate(cert)];
                                        case 2:
                                            revoked = _a.sent();
                                            if (revoked) {
                                                // do we need to do something about this?
                                                count++;
                                            }
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/, count];
                }
            });
        });
    };
    /**
     * Helper function to forward authorization. If better control on error is
     * required, instanciate the AuthorizationForwarder manually
     *
     * @param forwardToUrl base url where /prepare and /signed should be called.
     * Can also be an object containing both
     * @param resourceUri The resource URI to forward resource for
     * @param options any additional configuration for the authorization
     * forwarding
     */
    Agent.prototype.forwardAuthorization = function (forwardToUrl, resourceUri, options) {
        return __awaiter(this, void 0, void 0, function () {
            var inst;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inst = new AuthorizationForwarder.AuthorizationForwarder(this, forwardToUrl, resourceUri, options);
                        return [4 /*yield*/, inst.solve()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, inst];
                }
            });
        });
    };
    /**
     * Allow encryption using the agent public key, that can then later be
     * decrypted by our own private key
     */
    Agent.prototype.encrypt = function (payload) {
        if (!RSA_1.default.supports('encryptPublic')) {
            return Promise.reject('This implementation does not support encryption using public key');
        }
        return RSA_1.default.encryptPublic(this.keypair.pub, payload).then(shared_1.escape);
    };
    Agent.prototype.decrypt = function (cipher) {
        if (!RSA_1.default.supports('decryptPrivate')) {
            return Promise.reject('This implementation does not support decryption using private key');
        }
        return RSA_1.default.decryptPrivate(this.keypair.prv, (0, shared_1.unescape)(cipher));
    };
    return Agent;
}(ValidatingAgent_1.default));
exports.Agent = Agent;
exports.default = Agent;
